export const removeWhitespace = (obj) => {
    if (typeof obj === 'string') {
        return obj?.length ? obj.trim() : ''
    } else if (Array.isArray(obj)) {
        return obj.map(removeWhitespace)
    } else if (typeof obj === 'object' && obj !== null) {
        Object.keys(obj).forEach(function (key) {
            const value = removeWhitespace(obj[key])
            if (value === '' || value === undefined || value === null) {
                delete obj[key]
            } else {
                obj[key] = value
            }
        })
        return obj
    } else {
        return obj
    }
}
